// extracted by mini-css-extract-plugin
export default {"error-message":"Error_error-message__NHFm-"};